export default "__VITE_ASSET__517015d1__"